import React from 'react';

import ethImg from '../../assets/ethereum.png';

import './Networks.css';

function Networks(props) {
    return (
        <div className="ghost-network-container">
            <div className="ghost-network-list">
	        <div onClick={() => props.setNetwork(props.networks[0])} className={props.network !== 'ethereum' ? "ghost-network-list-cell" : "ghost-network-list-cell-active"}>
	            <img src={ethImg} alt="ethereum"></img>
	            <span>{props.networks[0]}</span>
	        </div>
	        <div onClick={() => props.setNetwork(props.networks[1])} className={props.network !== 'astral' ? "ghost-network-list-cell" : "ghost-network-list-cell-active"}>
	            <img src={ethImg} alt="ethereum"></img>
	            <span>{props.networks[1]}</span>
	        </div>
	        <div onClick={() => props.setNetwork(props.networks[2])} className={props.network !== 'binance' ? "ghost-network-list-cell" : "ghost-network-list-cell-active"}>
	            <img src={ethImg} alt="ethereum"></img>
	            <span>{props.networks[2]}</span>
	        </div>
	    </div>

	    <div className="ghost-network-buttons">
	        <div onClick={() => props.setToOrFrom(!props.toOrFrom)} className="ghost-network-buttons-button">{props.toOrFrom ? "From GHOST" : "To GHOST"}</div>
	        <div onClick={() => props.setStep(props.step+1)} className="ghost-network-buttons-button">Next Step</div>
	    </div>
	</div>
    );
}

export default Networks;
